<template>
<div class="Index">
    <!-- Navigation Section -->

    <div class="navbar navbar-fixed-top custom-navbar" role="navigation">
        <div class="container">
            <!-- navbar header -->
            <div class="navbar-header">
                <button class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                    <span class="icon icon-bar"></span>
                    <span class="icon icon-bar"></span>
                    <span class="icon icon-bar"></span>
                </button>
                <a href="#" class="navbar-brand">XINYU Development</a>

                <p class="navbar-l-brand">Solar Energy Monitoring System</p>
            </div>

            <div class="collapse navbar-collapse">
                <ul class="nav navbar-nav navbar-right">
                    <li>
                        <router-link :to="{ name: 'Total'}">全覽</router-link>
                    </li>
                    <li>
                        <a href="http://monitors.xinyu2008.com.tw" target="_blank" class="smoothScroll">監控</a>
                    </li>
                    <li>
                        <a href="http://xinyu2008.com.tw/" target="_blank" class="smoothScroll">信宇開發有限公司</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!-- Home Section -->

    <section id="home" class="parallax-section">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-sm-6">
                    <div class="home-img"></div>
                </div>

                <div class="col-md-6 col-sm-6">
                    <div class="home-thumb">
                        <div class="section-title">
                            <h4 class="wow fadeInUp" data-wow-delay="0.3s">SOLAR Monitoring</h4>
                            <h1 class="wow fadeInUp" data-wow-delay="0.6s">太陽能光電同步監控系統</h1>
                            <p class="wow fadeInUp" data-wow-delay="0.9s">案場相關資訊查詢｜交直流發電資訊查詢｜錯誤訊息查詢｜案場連線狀態</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import "bootstrap";

export default {
    name: "Index"
};
</script>

<style src="@/assets/index/css/bootstrap.min.css" scoped></style>
<style src="@/assets/index/css/animate.css" scoped></style>
<style src="@/assets/index/css/font-awesome.min.css" scoped></style>
<style src="@/assets/index/css/templatemo-style.css" scoped></style>
